/**
 * @deprecated
 * Queue Messaging Specs handler.
 *
 * Abbreviations:
 * EWT - Estimated Wait Time
 * QMS - Queue Messaging Spec(s)
 *
 * Based on the criteria described in the ticket PORTALV2-5918
 *
 * If a queue messaging spec is defined, then use that spec.
 * Otherwise, use the config described in the skin MXML.
 *
 * Default Queue Message when Agents are offline:
 *  this is the message that will be displayed when agents are offline.
 * It will be a single message looped every X seconds as defined in the configuration.
 *
 * Variables in the displayed message.
 * For example, entering:
 * "You're in our chat queue in position <<QUEUE-POSITION>>"
 * will be displayed to the user as:
 * "You're in our chat queue in position 3"
 *
 * The following variables are available:
 *  Queue Position
 *  Estimated Wait Time full – i.e. "5:30"
 *  Estimated Wait Time minutes – i.e. "5"
 *  Estimated Wait Time in minutes only – i.e. "3 minutes"
 *  Estimated Wait Time seconds – i.e. "30"
 *  Estimated Wait Time in seconds only – i.e. "150 seconds"
 *
 * The actual text in the box for variables should display as the following:
 *  <<QUEUE-POSITION>>
 *  <<FULL>>
 *  <<MINUTES>>
 *  <<MINUTES-ONLY>>
 *  <<SECONDS>>
 *  <<SECONDS-ONLY>>
 *
 * Logic to process queue messages:
 *  - Customer enters chat queue and receives an estimated wait time (EWT).
 *  - Pick the lowest message set that is greater than the EWT.
 *    For example, if the EWT is 599 seconds then the 600s message set is processed.
 *  - Begin processing the message set.
 *    If the EWT drops below to the next message set, then begin processing that new set instead.
 *
 * Note:
 *  the message set EWT takes priority over messages.
 *  For example, if the EWT drops to the next level before all messages of the previous set is processed,
 *  then the remaining messages in the previous set is skipped.
 *
 * Example:
 *  Queue Messaging Spec has the following message sets:
 *    600s (3 total messages): Messages #1, #2, #3.
 *    500s (3 total messages): Messages #4, #5, #6.
 *
 *  Let's say the queue is currently displaying message #2.
 *  If the EWT drops below 500s before message #3 is displayed,
 *  then #3 is skipped an #4 is displayed instead.
 *
 * The source of data:
 * queueMessagingSpecs: {
 * 		<specId>: {Object}
 * }
 * @see siteDefaultData.jsp
 * *
 * Example of Queue messaging spec:
 * @example this.spec
 * // <specId>:
 * // {
 * // 	name: "test1",
 * //	aom: "offline", // agent offline message
 * // 	aori: 2, // agent offline repeat interval
 * // 	qms: [] // queue messaging sets, Array of objects
 * // }
 *  @see queue-messaging-spec-model.jsp
 *
 *  Example of Queue messaging set:
 *  @example this.set
 * //qms: [// queue messaging sets
 * //	{
 * //		ewt: 200, // EWT remaining in seconds
 * //		qm: [] // queue messages, Array of objects
 * //	}
 * // ]
 * @see queue-messaging-set-model.jsp
 *
 * @example of Queue message:
 * // {
 * //	mo: 1, // message order
 * //	mt: "All of our agents are currently busy. Please wait and an agent will be with you shortly", // message text
 * //	dt: 1, // display times
 * //	ris: 1 // repeat interval seconds
 * // }
 * @see queue-messages-model.jsp
 *
 * @param {com.inq.flash.client.control.messagehandlers.NeedWaitHandler} parent
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler = function(parent) {
	this.needWaitHandler = parent;
	this.spec = this.getQueueMessagingSpec();
	this.isEnabled = !!this.spec;
	this.setId = null;
	this.set = null;
	/** @type number */
	this.lastProcessedQueueMsg = Date.now();

	this.currentPosition = null;
	this.currentEstTime = null;
	this.currentTimeout = null;
	this.isAgentAvailable = true;
	this.pendingTimer = null;
};
$hxClasses.registerClass(com.inq.flash.client.control.messagehandlers.QueueMessagingHandler, "com.inq.flash.client.control.messagehandlers.QueueMessagingHandler");

/**
 * Receives the object of specified Queue Messaging Spec from default site settings for current chat theme.
 * And then sorts the collection of sets ascending according to estimated wait time.
 * @returns {?Object} object of QMS or null
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.getQueueMessagingSpec = function() {
	/** @type {Object} */
	var qmSpec = com.inq.flash.client.control.FlashPeer.getQueueMessagingSpec();

	if (qmSpec) {
		/** @type {string} */
		var ewtKey = this.QMS.EWT_REMAINING_IN_SECONDS;
		// sorting the collection of sets ascending according to estimated wait time
		qmSpec[this.QMS.SETS].sort(function(a, b) {
			return a[ewtKey] - b[ewtKey];
		});
	}

	return qmSpec;
};

/**
 * This method processes the messages from default settings of site data according to Queue Messaging Specs.
 *
 * @param {com.inq.flash.messagingframework.Message} message - the processed message
 * @param {string} agentName
 * @returns {string} - the text of the message
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.msgProcessing = function (message, agentName) {

	this.currentPosition = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_WAIT_POS);
	this.currentEstTime = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_WAIT_EST_ASSIGN_TIME);
	this.keyReplay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY);
	this.agentName = agentName;

	//It is needed to stop displaying current message if agent availability just changed.
	if (this.currentEstTime == -1) {
		// special case when KEY_CHAT_WAIT_EST_ASSIGN_TIME == -1, no agents are available
		if (this.isAgentAvailable && this.pendingTimer) {
			clearTimeout(this.pendingTimer);
			this.pendingTimer = null;
		}
		this.isAgentAvailable = false;
	} else {
		if (!this.isAgentAvailable && this.pendingTimer) {
			clearTimeout(this.pendingTimer);
			this.pendingTimer = null;
		}
		this.isAgentAvailable = true;
	}

	//Start timer only when it is not started.
	if (!this.pendingTimer) {
		this.startTimer();
	}
};

/**
 * Starts displaying Queue Message after calculated timeout.
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.startTimer = function () {
	/** @type {?number} */
	var timeout = this.nextWaitTime();
	/** @type {com.inq.flash.client.control.messagehandlers.QueueMessagingHandler} */
	var that = this;
	if (timeout >= 0) {
		this.currentTimeout = timeout;
		this.pendingTimer = setTimeout(function () {
			that.displayQueueMessage();
		}, timeout);
	} else {
		this.pendingTimer = null;
	}
};

com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.clearPendingTimer = function () {
	if (this.pendingTimer) {
		clearTimeout(this.pendingTimer);
		this.pendingTimer = null;
	}
};

/**
 * Calculates time to display next queue message.
 * @returns {number} time in milliseconds.
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.nextWaitTime = function () {
	/** @type {number} */
	var secondWaitTime = Math.floor(this.currentEstTime / 1000);
	/** @type {number} */
	var result = -1;
	/** @type {number} */
	var period = (new Date().getTime() - this.lastProcessedQueueMsg) / 1000;
	if (this.isAgentAvailable) {
		this.updateActiveSet(secondWaitTime);
		result = parseInt(this.set[this.QMS.MESSAGES][this.msgId][this.QMS.REPEAT_INTERVAL_IN_SECONDS]) - period;
	} else {
		// special case when KEY_CHAT_WAIT_EST_ASSIGN_TIME == -1, no agents are available
		result = parseInt(this.spec[this.QMS.AGENT_OFFLINE_REPEAT_INTERVAL]) - period;
	}
	return result > 0 ? result * 1000 : 0;
}

/**
 * Extracted next queue message from the configuration set, displays it to customer. This method is called recursive via setTimeout function.
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.displayQueueMessage = function () {
	if (!com.inq.flash.client.chatskins.SkinControl.applicationController.isChatInQueue() || this.needWaitHandler.framework.isSendMessageFail()) {
		this.pendingTimer = null;
		return;
	}
	/** @type {string} */
	var queueingMsg;
	if (this.isAgentAvailable) {
		//Adjust currentEstTime. Extract currentTimeout from currentEstTime.
		if (this.currentEstTime && this.currentTimeout) {
			this.currentEstTime -= this.currentTimeout;
		}
		if (this.currentEstTime < 0) {
			this.currentEstTime = 0;
		}

		/** @type {number} */
		var milliSecondWaitTime = parseInt(this.currentEstTime);
		if (!isNaN(milliSecondWaitTime)) {
            this.updateActiveSet(milliSecondWaitTime / 1000);
			queueingMsg = this.substituteEWT(this.set[this.QMS.MESSAGES][this.msgId][this.QMS.MESSAGE_TEXT], milliSecondWaitTime);
			queueingMsg = this.substituteQP(queueingMsg, this.currentPosition);
			this.updateMsgOrder();
		}
	} else {
		queueingMsg = this.spec[this.QMS.AGENT_OFFLINE_MSG] || this.needWaitHandler.needwaitMessageDefault;
	}
	this.needWaitHandler.sendQueueingMsgString(this.agentName, queueingMsg, this.keyReplay);
	this.lastProcessedQueueMsg = Date.now();
	//Recursively call the method until time >= 0;
	this.startTimer();
};

/**
 * Selects the current active set of messaging according to the current waiting time.
 * Set is an object contains parameters of the specified set.
 *
 * If the set the same as the current, it is not changed.
 * When the set changes the message counter is drops to default value
 *  and sorts messages in the set ascending according to the parameter message order.
 *
 * Note:
 *  Collection of sets could not be empty!
 *  According to the current implementation the first set (with index 0)
 *   always should contain the value of remaining wait time equal "-1" that means the infinity
 *   sets[0][EWT_REMAINING_IN_SECONDS] == -1
 *
 * @param waitTime {number} - the time interval in seconds
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.updateActiveSet = function(waitTime) {
	/** @type {Array} */
	var sets = this.spec[this.QMS.SETS];
	/** @type {number} */
	var currentSetId = 0;

	var sortKey = this.QMS.MESSAGE_ORDER;

	// according to the current implementation the first set (with index 0)
	// always should contain the value of remaining wait time equal "-1" that means the infinity
	// sets[0][EWT_REMAINING_IN_SECONDS] == -1
	// thus we can miss it and will use it for determination of current set different from infinity
	for (var i = 1; i < sets.length; i++) {
		if (waitTime <= sets[i][this.QMS.EWT_REMAINING_IN_SECONDS]) {
			currentSetId = i;
			break;
		}
	}

	if (this.setId == null) {
		// New or Refreshed.
		this.setId = currentSetId;
		this.set = sets[currentSetId];
		this.msgId = com.inq.flash.client.control.PersistenceManager.GetValue(QUEUE_MESSAGE_ID, 0);
		this.msgCount = com.inq.flash.client.control.PersistenceManager.GetValue(QUEUE_MESSAGE_COUNT, 0);

		this.set[this.QMS.MESSAGES].sort(function(a, b) {
			return a[sortKey] - b[sortKey];
		});
	} else if (this.setId != currentSetId) {
		this.setId = currentSetId;
		this.set = sets[currentSetId];
		this.msgId = 0;
		this.msgCount = 0;
		com.inq.flash.client.control.PersistenceManager.SetValue(QUEUE_MESSAGE_ID, this.msgId);
		com.inq.flash.client.control.PersistenceManager.SetValue(QUEUE_MESSAGE_COUNT, this.msgCount);

		this.set[this.QMS.MESSAGES].sort(function(a, b) {
			return a[sortKey] - b[sortKey];
		});
	}
};

/**
 * Checks the period after processing of latest message for the state when agent is offline.
 * @returns {boolean}
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.isThresholdAgentOfflineMsg = function() {
	/** @type {number} */
	var period = (new Date().getTime() - this.lastProcessedQueueMsg) / 1000;
	return period >= Std.parseInt(this.spec[this.QMS.AGENT_OFFLINE_REPEAT_INTERVAL]);
};

/**
 * Checks the period after processing of latest message for processing of current QMS set.
 * @returns {boolean}
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.isThresholdMsg = function() {
	/** @type {number} */
	var period = (new Date().getTime() - this.lastProcessedQueueMsg) / 1000;
	return period >= Std.parseInt(this.set[this.QMS.MESSAGES][this.msgId][this.QMS.REPEAT_INTERVAL_IN_SECONDS]);
};

/**
 * This method substitutes the pattern of Estimated Wait Time in the text with the specified substitution
 * @example "An agent will be with you in <<SECONDS-ONLY>> seconds"
 * // "An agent will be with you in 40 seconds"
 * @example "You are number <<QUEUE-POSITION>> in the queue"
 * // "You are number 3 in the queue"
 *
 * @private
 * @this com.inq.flash.client.control.messagehandlers.QueueMessagingHandler
 *
 * @param {string} waitText - the base text with text strings to be replaced
 * @param {number} waitTime - the total waiting time in milliseconds that was received from the Chat Router
 * @returns {string}
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.substituteEWT = function(waitText, waitTime) {
	if (waitText == "") {
		// if there is no text in message, there is nothing to processing
		return waitText;
	}

	/** @type {string} */
	var queueingMsg = waitText;

	/** @type {number} */
	var secondWaitTime = Math.floor(waitTime / 1000);

	// The map time field values must conform to the #QueueMessagingHandler.EWT map for a comprehensive substitution
	/** @type {Object} */
	var timeMap = {
		MINUTES: Math.floor(secondWaitTime / 60),
		MINUTES_ONLY: Math.round(secondWaitTime / 60),
		SECONDS: Math.floor(secondWaitTime % 60),
		SECONDS_ONLY: Math.floor(secondWaitTime)
	};
	timeMap.FULL = timeMap.MINUTES + (timeMap.SECONDS < 10 ? ":0" : ":") + timeMap.SECONDS;

	for (var k in this.EWT) {
		queueingMsg = this.substituteText(queueingMsg, this.EWT[k], timeMap[k]);
	}

	return queueingMsg;
};

/**
 * Updates the message count
 * and if the limit was exceeded by the number of displays of the current message,
 *  updates the message id for current QMS set
 *  and drops the message counter to the default value (0).
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.updateMsgOrder = function() {
	this.msgCount++;
	com.inq.flash.client.control.PersistenceManager.SetValue(QUEUE_MESSAGE_COUNT, this.msgCount);

	/** @type {Array} */
	var msgCollection = this.set[this.QMS.MESSAGES];

	if (msgCollection[this.msgId][this.QMS.DISPLAY_TIMES] <= this.msgCount) {
		if (msgCollection[this.msgId + 1]) {
			this.msgId++;
			com.inq.flash.client.control.PersistenceManager.SetValue(QUEUE_MESSAGE_ID, this.msgId);
			this.msgCount = 0;
			com.inq.flash.client.control.PersistenceManager.SetValue(QUEUE_MESSAGE_COUNT, this.msgCount);
		} else {
			haxe.Log.trace("[QueueMessagingHandler] Was reached the threshold of the queue messaging. There is no next message. Message count: " + this.msgCount);
		}
	}
};

/**
 * This method substitutes QUEUE_POSITION in text
 * with the text specified in position parameter.
 * @example "You are number <<QUEUE-POSITION>> in the queue"
 * // "You are number 3 in the queue"
 *
 * @private
 * @this com.inq.flash.client.control.messagehandlers.QueueMessagingHandler
 *
 * @param {string} text - the text to be searched for the given pattern parameter
 * @param {string} position - value for replacement
 * @returns {string}
 */

com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.substituteQP = function (text, position) {
	return this.needWaitHandler.substituteQP(text, this.needWaitHandler.needwaitMessageDefault, position);
};
/**
 * This method substitutes pattern in text with the text specified in the substitution.
 * @example "An agent will be with you in <<SECONDS-ONLY>> seconds"
 * // "An agent will be with you in 40 seconds"
 * @example "You are number <<QUEUE-POSITION>> in the queue"
 * // "You are number 3 in the queue"
 *
 * @private
 * @this com.inq.flash.client.control.messagehandlers.QueueMessagingHandler
 *
 * @param {string} text - the text to be searched for the given pattern parameter
 * @param {(string|RegExp)} pattern - the pattern to be matched and substituted
 * @param {string=} substitute - string for text to be replaced
 * @returns {string}
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.substituteText = function(text, pattern, substitute) {
	return this.needWaitHandler.substituteText(text, this.needWaitHandler.needwaitMessageDefault, pattern, substitute);
};

/**
 * Repository of patterns for Estimated Wait Time.
 * Map of string values.
 * @private
 * @type {Object}
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.EWT = {
	FULL: "<<FULL>>",
	MINUTES: "<<MINUTES>>",
	MINUTES_ONLY: "<<MINUTES-ONLY>>",
	SECONDS: "<<SECONDS>>",
	SECONDS_ONLY: "<<SECONDS-ONLY>>"
};

/**
 * Repository of properties for Queue Messaging Spec.
 * Map of string values.
 * @private
 * @type {Object}
 */
com.inq.flash.client.control.messagehandlers.QueueMessagingHandler.prototype.QMS = {
	AGENT_OFFLINE_MSG: "aom",
	AGENT_OFFLINE_REPEAT_INTERVAL: "aori",
	SETS: "qms",
	EWT_REMAINING_IN_SECONDS: "ewt",
	MESSAGES: "qm",
	MESSAGE_ORDER: "mo",
	MESSAGE_TEXT: "mt",
	DISPLAY_TIMES: "dt",
	REPEAT_INTERVAL_IN_SECONDS: "ris"
};